import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getBankId } from '../states/session/selectors';
import { createContent } from '../helpers/content';

const mapState = (state) => ({
	bankId: getBankId(state),
});

export default (options) => (WrappedComponent) => {
	const withContent = class extends Component {
		constructor(props) {
			super(props);

			const content = props.contentKey ? options.content[props.contentKey] : options.content;

			this.state = {
				content: createContent(content, props.bankId),
			};
		}

		render() {
			return <WrappedComponent {...this.props} content={this.state.content} />;
		}
	};

	withContent.displayName = `WithContent(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	withContent.propTypes = {
		contentKey: PropTypes.string,
		bankId: PropTypes.string,
	};

	return connect(mapState)(withContent);
};
